import { GoogleRoutingStrategy } from './GoogleRoutingStrategy';
import { HereRoutingStrategy } from './HereRoutingStrategy';

export function createRoutingStrategy(provider, apiKey) {
  const normalizedProvider = String(provider || 'google').toLowerCase().trim();

  if (normalizedProvider === 'here') {
    return new HereRoutingStrategy(apiKey);
  }

  return new GoogleRoutingStrategy(apiKey);
}
